<template>
<div></div>
</template>

<script>
export default {
	name: "KakaoPopup",	
	computed: {
		routeName() {
            return this.$route.name;
        },
	},
	created() {
		this.$store.state.header = false;
		this.$store.commit('SHOW_ONLOAD');
		this.$store.commit('START_LOADING')
	},
	methods: {},
}
</script>
